module.exports = __webpack_public_path__ + "2b922cc4d6378af53a7f5e3cfb2f5df1.svg";